export { default } from 'Components/Cart/CartTable/CartTable'
